<template>
  <AccountNewVacancyPageInner v-if="isStoreModuleRegistered"
                              ref="inner"
                              :key="key"/>
</template>

<script>
  const storeModule = () => import(/* webpackChunkName: "account-page" */ '../../store/_vacancyEdit')
  import AccountNewVacancyPageInner from './AccountNewVacancyPageInner'

  export default {
    components: {
      AccountNewVacancyPageInner
    },
    data() {
      return {
        key: 1,
        isStoreModuleRegistered: false,
        confirm: {
          title: 'Leave this page?',
          message: "If you leave this page, some changes wasn't save",
        },
      }
    },
    computed: {},
    methods: {
      setListeners() {
        window.addEventListener('unload', this.onLeave)
        window.addEventListener('beforeunload', this.onLeave)
      },
      removeListeners() {
        window.removeEventListener('unload', this.onLeave)
        window.removeEventListener('beforeunload', this.onLeave)
      },
      onLeave(e) {
        if (this.shouldPreventReload) {
          e.preventDefault()
          e.returnValue = `${this.$tGlobal(this.confirm.title)} ${this.$tGlobal(this.confirm.message)}`
        }
      }
    },
    async created() {
      debugger
      if(!this.$store.state.vacancyEdit) {
        await storeModule().then(module => {
          this.$store.registerModule('vacancyEdit', module.default)
        })
      }

      this.isStoreModuleRegistered = true

      this.setListeners()
    },
    beforeDestroy() {
      this.removeListeners()
    },
    watch: {
      '$route.name'() {
        this.key += 1
      }
    },
    beforeRouteLeave(to, form, next) {
      if (this.$refs.inner && this.$refs.inner.shouldPreventReload) {
        this.$vModal.open('confirm-vacancy-leave', {
          title: this.$tGlobal(this.confirm.title),
          message: this.$tGlobal(this.confirm.message),
          onLeaveClick: () => {
            this.$vModal.close('confirm-vacancy-leave')
            next()
          },
          onSaveLeaveClick: () => {
            let newRoute = {name: to.name, params: {...to.params}, query: {...to.query}}
            this.$vModal.close('confirm-vacancy-leave')
            this.onSave(false, true, newRoute)
          }
        })
      } else {
        next()
      }
    }
  }
</script>

<style lang="less">

</style>
